import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import usePageBodyClass from "../utils/usePageBodyClass";
import "./AdminLogin.css";

const $ = window.$;

export default function AdminLogin() {
  usePageBodyClass("page-admin-login");
  const navigate = useNavigate();

  useEffect(() => {
    function updateLiveDateTime() {
      const now = new Date();
      const options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      $("#liveDateTime").text(now.toLocaleDateString("en-US", options));
    }
    updateLiveDateTime();
    const clockTimer = setInterval(updateLiveDateTime, 1000);

    $("#adminLoginForm").on("submit.pageAdminLogin", function (e) {
      e.preventDefault();
      $("#loginError").hide();

      const username = $("#adminUsername").val().trim();
      const password = $("#adminPassword").val().trim();

      if (username === "admin" && password === "admin123") {
        sessionStorage.setItem("adminSession", "active");
        navigate("/admin/dashboard");
      } else {
        $("#loginError").show();
      }
    });

    return () => {
      clearInterval(clockTimer);
      $("#adminLoginForm").off(".pageAdminLogin");
    };
  }, [navigate]);

  return (
    <div className="page-admin-login">
      <div className="header-datetime-top">
        <i className="fa-regular fa-calendar-days me-2 text-warning"></i>
        <span id="liveDateTime">Loading Date &amp; Time...</span>
      </div>

      <div className="admin-login-card my-4">
        <div className="admin-header">
          <i className="fa-solid fa-user-shield fa-3x mb-2 text-warning"></i>
          <h4 className="fw-bold mb-1">Admin Portal</h4>
          <p className="text-secondary small mb-0 text-light">Exam Results &amp; Monitoring Panel</p>
        </div>

        <div className="p-4">
          <form id="adminLoginForm" noValidate>
            <div className="mb-3">
              <label htmlFor="adminUsername" className="form-label fw-bold small text-secondary">
                Admin Username
              </label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fa-solid fa-user text-muted"></i>
                </span>
                <input type="text" className="form-control" id="adminUsername" placeholder="admin" required />
              </div>
            </div>

            <div className="mb-4">
              <label htmlFor="adminPassword" className="form-label fw-bold small text-secondary">
                Password
              </label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fa-solid fa-lock text-muted"></i>
                </span>
                <input
                  type="password"
                  className="form-control"
                  id="adminPassword"
                  placeholder="••••••••"
                  required
                />
              </div>
              <div className="error-msg" id="loginError">
                Invalid Username or Password! (Default: admin / admin123)
              </div>
            </div>

            <button type="submit" className="btn btn-admin w-100 mb-3">
              <i className="fa-solid fa-right-to-bracket me-2"></i>Login to Dashboard
            </button>

            <div className="text-center small text-muted">
              <Link to="/login" className="text-decoration-none text-secondary">
                <i className="fa-solid fa-arrow-left me-1"></i>Switch to Student Login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
